import React from 'react'
import Adminnav from '../Adminnav'

const RemoveHub = () => {
  return (
    <>
    <Adminnav/>
    <section id="hero">
      <div className="hero-container">
        <div className="hero-logo row">
          <h1 className="font-weight-bold col">Remove Distribution Hub</h1>
        </div>
      </div>
    </section>
    <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 h-100 w-100 p-5 mx-auto">
          {/* {sellers
          ? sellers.map((data) => (
              
              <div className="col singleCard card target py-5" id={data.sellerId}>
              <div className="col card-body text-center">
                  <h4>{data.sellerId}</h4>
                  <h6>Owner Name: {data.ownerName}</h6>
                  <button className='btn btn-success rmvSeller'onClick={()=>remove(data.sellerId)}>Remove</button>
                  </div>
              </div>
              

          )):""} */}
           </div>
          
  </>
  )
}

export default RemoveHub